
define('text!views/DefaultError.html',[],function () { return '<div id="OtherQualitative">\r\n    <div class="container-fluid">\r\n        <!--Page Body Section-->\r\n        <div class="row-fluid">\r\n            <div id="errorres" class="alert-warning"><label class="control-label">Some Error Occured</label></div>\r\n        </div>\r\n    </div>\r\n</div>';});

